import {
  LOGIN_REQUESTING,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGIN_REDIRECT,
  CLEAR_MESSAGES
} from './constants'

const initialState = {
  type: '',
  redirect: '',
  data: {},
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
  history: {}
}

const reducer = function loginReducer (state = initialState, action) {
  switch (action.type) {
    // Set the requesting flag and append a message to be shown
    case LOGIN_REQUESTING:
      return {
        ...state,
        type: action.type,
        redirect: '',
        requesting: true,
        successful: false,
        messages: [{ body: 'Đang xử lý...', time: new Date() }],
        errors: [],
      }

    // Successful?  Reset the login state.
    case LOGIN_SUCCESS: 
      return {
        ...state,
        type: action.type,
        redirect: action.data.redirect || LOGIN_REDIRECT,
        data: action.data,
        errors: [],
        messages: [{ body: action.data.messages, time: new Date() }],
        requesting: false,
        successful: true,
      }

    // Append the error returned from our api
    // set the success and requesting flags to false
    case LOGIN_ERROR:
      return {
        ...state,
        type: action.type,
        redirect: '',
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
        messages: [],
        requesting: false,
        successful: false,
      }

    case CLEAR_MESSAGES:
      return {
        ...state,
        errors: [],
        messages: [],
      }

    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/Pages/Login/reducer.js